export const useDate = () => {
  const setDateFormat = (data?: string | null) => {
    if (!data) {
      return '';
    }

    const date = new Date(data);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    return `${day}.${month}.${date.getFullYear()}`;
  };

  return { setDateFormat };
};
